module.exports = __webpack_public_path__ + "static/media/conversational-ai-icon.6621d025.svg";